import React from "react";
import { Row, Col, Alert, Icon } from "antd";

const CouponCode = props => {

    const { code } = props;

    let messageRow = <Row><Col span={20}>
        {code}
    </Col><Col span={4} style={{ textAlign: "right" }}>
            <Icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" />
        </Col></Row>;

    return (
        <Row type="flex" justify="space-between" align="middle" gutter={8}>
            <Col span={24} style={{ marginTop: "0.75rem" }}>
                <Alert type={"success"} message={messageRow} />
            </Col>
        </Row>
    );
};

export default CouponCode;
